import { render, staticRenderFns } from "./Collected.vue?vue&type=template&id=318c7b26"
import script from "./Collected.vue?vue&type=script&lang=js"
export * from "./Collected.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports